import { gql, useMutation } from '@apollo/client'

const GET_INVITATION_INFO = gql`
  query Invitation($id: ID!) {
    invitation(id: $id) {
      invitedBy {
        ... on Coach {
          name
        }
      }
      canAccept
    }
  }
`

const ACCEPT_SPONSORSHIP = gql`
  mutation AcceptSponsorship($id: ID!) {
    acceptInvitation(id: $id) {
      success
      message
    }
  }
`

const useAcceptSponsorship = () => {
  const [acceptSponsorship, result] = useMutation(ACCEPT_SPONSORSHIP)
  const accept = id => {
    return acceptSponsorship({
      variables: { id },
    })
  }
  return [accept, result]
}

export { GET_INVITATION_INFO, useAcceptSponsorship }
